<template>
<!-- 服务伙伴 -->
  <div class="container">
    <div class="partner">
      <h2>{{title}}</h2>
    </div>
    <div class="anli-more flex-align-center flex-center" v-if="showDot">
      <i class="dot"></i>
      <i class="dot"></i>
      <i class="dot"></i>
    </div>
    <el-row class="count-list partner-row">
      <el-col class="sm-and-up" v-for="(item, index) in partnerList" :key="index">
        <div class="partner-item flex-align-center flex-center">
          <div class="partner-img">
            <img :src="item.image" alt="">
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    showDot: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      partnerList: [
        {
          image: require('../../assets/image/partner/partner-1.png')
        },
        {
          image: require('../../assets/image/partner/partner-2.png')
        },
        {
          image: require('../../assets/image/partner/partner-3.png')
        },
        {
          image: require('../../assets/image/partner/partner-4.png')
        },
        {
          image: require('../../assets/image/partner/partner-5.png')
        },
        {
          image: require('../../assets/image/partner/partner-6.png')
        },
        {
          image: require('../../assets/image/partner/partner-7.png')
        },
        {
          image: require('../../assets/image/partner/partner-8.png')
        },
        {
          image: require('../../assets/image/partner/partner-9.png')
        },
        {
          image: require('../../assets/image/partner/partner10.png')
        },
        {
          image: require('../../assets/image/partner/partner11.png')
        },
        {
          image: require('../../assets/image/partner/partner12.png')
        },
        {
          image: require('../../assets/image/partner/partner13.png')
        },
        {
          image: require('../../assets/image/partner/partner14.png')
        },
        {
          image: require('../../assets/image/partner/partner15.png')
        },
      ]
    }
  },
}
</script>
